/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileAnalyticsCumulativeHistogram } from '../../models/profile-analytics-cumulative-histogram';

export interface ProfileFollowersDateHistogram$Params {
  id: number;
}

export function profileFollowersDateHistogram(http: HttpClient, rootUrl: string, params: ProfileFollowersDateHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>> {
  const rb = new RequestBuilder(rootUrl, profileFollowersDateHistogram.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>;
    })
  );
}

profileFollowersDateHistogram.PATH = '/analytics/profile/{id}/followers';
